import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/auth/logout',
  name: ROUTE_NAME.AUTH_LOGOUT,
  meta: {
    title: '登出'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "auth" */
      '@/pages/auth/logout.vue'),
      loading: Loading
    };
  }
}];